export enum EModelApiPaths {
    API = '/api',
    CUSTOM_API_BASE = '/custom-api',
    SYSTEM_API_BASE = '/system-api',
    THIRD_PARTY_API_BASE = '/third-party',

    DOWNLOAD_FILE = '/aws-s3-bucket/1.0.0/download-file',
    DELETE_FILE = '/aws-s3-bucket/1.0.0/delete-file',
    FILE_UPLOAD = '/aws-s3-bucket/1.0.0/upload-file',

    USER_LOGIN = '/pb-login',
    USER_REGISTER = '/user-register',
    CREATE_CAPTCHA = '/create-captcha',
    FILE_UPLOAD_PUBLIC = '/public/upload-file-public',
    CHECK_EMAIL_EXIST = '/public/check-email-exist',
    FORGOT_PIN = '/public/forgot-pin',
    SEND_EMAIL_PIN = '/public/send-pin-email-brevo',
    VERIFY_EMAIL_PIN = '/public/verify-email-pin',
    ADMIN_DASHBOARD_GET_DATA_STUDENTS = '/admin_dashboard/admin-dashboard-get-data-students',
    ADMIN_DASHBOARD_GET_DATA_COURSE_CREATOR = '/admin_dashboard/admin-dashboard-get-data-course-creators',
    STUDENTS_APPROVAL_CARDS = '/approval/student/students-approval-cards',
    GET_COURSE_CARDS_SPONSOR_DASHBOARD = '/get-course-cards-sponsor-dashboard',
    GET_CENTER_CARDS_SPONSOR_DASHBOARD = '/get-center-cards-sponsor-dashboard',

    GET_DISTINCT_STATE_CITY_NAME = '/get-distinct-state-city-name',
    GET_COURSE_CENTER_BATCH_FOR_DROPDOWN = '/get-courseName-center-batch-for-dropdown',
    GET_COURSE_CENTER_STUDENT_COUNT_FOR_SPONSOR_DASHBOARD = '/get-course-center-student-count-for-sponsor-dashboard',
    GET_ADMIN_DASHBOARD_TRAINER_COUNT = '/admin_dashboard/admin-dashboard-get-trainer-count',

    // CC dashboard
    GET_CC_DASHBOARD_COUNT = '/cc_dashboard/get-all-count-for-CC-dashboard',
    GET_CC_DASHBOARD_COURSE_CARDS_DATA = '/cc_dashboard/get-course-cards-data',
    GET_CC_DASHBOARD_CENTER_CARDS_DATA = '/cc_dashboard/get-center-cards-data',
    GET_CC_DASHBOARD_STUDENT_CARDS_DATA = '/cc_dashboard/get-student-cards-data',

    RECOMMEND_TRAINER_BY_CC = '/approval/cc/trainer/recommendTrainerByCC',
    APPROVE_TRAINER_BY_ADMIN = '/approval/admin/trainer/approveTrainerByAdmin',

    // trainer dashboard
    GET_TRAINER_DASHBOARD_COURSE_CARDS = '/trainer_dashboard/get-course-cards-for-trainer-dashboards',
    GET_TRAINER_DASHBOARD_CENTER_CARDS = '/trainer_dashboard/get-center-cards-for-trainer-dashboards',
    GET_TRAINER_DASHBOARD_CARDS_COUNT = '/trainer_dashboard/getTrainerDashboardCardsCount',
    CHECK_IF_NEW_QUIZ_ADDED = '/trainer_dashboard/checkIfNewQuizAdded',

    FILE_DOWNLOAD = '/aws-s3-bucket/1.0.0/download-file',

    // question bank
    GET_ALL_APPROVED_COURSES_BY_COURSE_ID = '/questionBank/getApprovedCoursesByCourseCreatorId',

    // dwp
    SAVE_AND_UPDATE_DWP = '/save-and-update-dwp',


    GET_STUDY_MATERIAL_STUDENT = '/get-study-material-student',
    GET_STUDY_MATERIAL_TRAINER = '/get-study-material-trainer',

    SAVE_WORK_LINK = '/save-work-link',
}
